

import React from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { routes } from '../routes';

interface PageProps {
   app_title: string;
}

export const HomePage: React.FC<PageProps> = (props) => {
   return (<React.Fragment>
        <h2>Welcome on {props.app_title}</h2>
        <ListGroup>
            <ListGroup.Item>
               <Link to={routes.accounts}  className="me-1">Accounts</Link>
              Accounts informations
            </ListGroup.Item>
            <ListGroup.Item>
               <Link to={routes.studies} className="me-1">Studies</Link>
               View studies and surveys installed 
            </ListGroup.Item>
            <ListGroup.Item>
               <Link to={routes.automessages}  className="me-1">Newsletters</Link>
              Auto messages & Newsletters
            </ListGroup.Item>
            <ListGroup.Item>
               <Link to={routes.templates}  className="me-1">Templates</Link>
               View system message templates
            </ListGroup.Item>

        </ListGroup>
   </React.Fragment>)
};

